import React, {useEffect, useState} from 'react';
import {useStores} from "../../../../stores/Context";
import axios from "axios";
import {useParams} from "react-router-dom";
import moment from "moment";
import ModalPrimary from "../../../../boiteAOutils/ModalPrimary";
import CorbeilleSvg from "../../../../boiteAOutils/SVG/CorbeilleSvg";


const WidgetConsignesContentHistory = (props) => {
    const {id, ent} = useParams();
    const {widgetStore, consignesStore} = useStores();
    const [dataTable, setDataTable] = useState([]);
    const [pending, setPending] = useState(true);
    const [isRestoreConsigne, setIsRestoreConsigne] = useState('');

    const [isDeleteConsigne, setIsDeleteConsigne] = useState('');

    useEffect(() => {
        if (pending) {
            axios.get(process.env.REACT_APP_API_URL + '/api/allConsignesHistoryByIdTotem/' + widgetStore.idTotem,
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then((res) => {
                setDataTable(res.data)
                setPending(false);
            });
        }
    }, [pending])

    const handleRestoreConsigne = () => {
        if (isRestoreConsigne) {
            axios.post(process.env.REACT_APP_API_URL + '/api/restoreConsigne', {
                    id: isRestoreConsigne,
                    id_totem: widgetStore.idTotem
                },
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then((res) => {
                setPending(true);
                setIsRestoreConsigne('');
                props.onRestore();
            })
        }
    }
    const handleDeleteConsigne = () => {
        if (isDeleteConsigne) {
            axios.post(process.env.REACT_APP_API_URL + '/api/deleteConsigne', {
                    id: isDeleteConsigne,
                    id_totem: widgetStore.idTotem
                },
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then((res) => {
                setPending(true);
                setIsDeleteConsigne('');
                props.onRestore();
            })
        }
    }

    return (
        <div>
            <div className={"consigneModifyBody"}>
                <div className={"consigneModifyHeader"}>
                    <h3 className={"consigneModifyTitleH3"}>Archives</h3>
                    <div onClick={() => consignesStore.resetViews()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                                  strokeWidth="2"/>
                        </svg>
                    </div>
                </div>

                <div className={"consigneModifyHeaderSeparateur"}></div>
                <div className={"consigneModifyBodyContent"}>

                    {
                        dataTable.map((data) => (
                            <div className={"consigneHistoryListe"}>
                                <div className={"consigneHistoryCard"}>
                                    <div className={"consigneHistoryCardTagColor"}
                                         style={{background: `${data.tag_color ?? null}`}}></div>
                                    <div className={"consigneHistoryCardContent"}>
                                        <div className={"consigneCardContentText"}
                                             dangerouslySetInnerHTML={{__html: data.content}}/>
                                        <div
                                            className={"consigneHistoryCardDate"}>{moment(data.created_at).format('DD MMMM YYYY')}</div>
                                    </div>
                                </div>
                                <div>
                                    <button type={"button"} className={"consigneHistoryRestorBtn"}
                                            onClick={() => setIsRestoreConsigne(data.id)}>
                                        Restaurer
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.7168 5L2.99972 12L9.7168 19" stroke="#A8B0B3" strokeWidth="2"/>
                                            <line y1="-1" x2="17.7331" y2="-1"
                                                  transform="matrix(1 0 0 -1 3.26758 11.0312)"
                                                  stroke="#A8B0B3" strokeWidth="2"/>
                                        </svg>
                                    </button>
                                    <br/>
                                    <button type={"button"} className={"consigneHistoryRestorBtn"}
                                            onClick={() => setIsDeleteConsigne(data.id)}>
                                        Supprimer
                                        <CorbeilleSvg couleur={"#A8B0B3"}/>
                                    </button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            {
                isRestoreConsigne ? (
                    <ModalPrimary
                        textTitle={'Êtes-vous sur de vouloir restaurer cette consigne ?'}
                        textBtnCancel={"Annuler"}
                        textBtnValidate={"Restaurer la consigne"}
                        onCancel={() => setIsRestoreConsigne('')}
                        onValidate={handleRestoreConsigne}
                    />
                ) : null
            }

            {
                isDeleteConsigne ? (
                    <ModalPrimary
                        textTitle={'Êtes-vous sur de vouloir supprimer cette consigne ?'}
                        textBtnCancel={"Annuler"}
                        textBtnValidate={"Supprimer la consigne"}
                        onCancel={() => setIsDeleteConsigne('')}
                        onValidate={handleDeleteConsigne}
                    />
                ) : null
            }
        </div>


    );
};

export default WidgetConsignesContentHistory;
